import type { MCPSharingUserItem } from "../../services/agent-tools-service";
import type { OrgUser } from "./hooks/useUsers";

const FULL_ACCESS_ORGANIZATION_ROLES = new Set(["admin", "owner"]);

export const requiresFullMcpAccess = (user: OrgUser | undefined): boolean =>
  FULL_ACCESS_ORGANIZATION_ROLES.has(
    user?.organizationRole?.trim().toLowerCase() ?? "",
  );

export const enforceOrganizationFullAccess = (
  selectedUsers: MCPSharingUserItem[],
  organizationUsers: OrgUser[],
): MCPSharingUserItem[] => {
  const protectedUserIds = new Set(
    organizationUsers
      .filter(requiresFullMcpAccess)
      .map((user) => user.id),
  );

  return selectedUsers.map((user) =>
    protectedUserIds.has(user.id) && user.role !== "owner"
      ? { ...user, role: "owner" }
      : user,
  );
};
